import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var chatBubbleIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.559 23.556c-.331 0-.651-.147-.856-.41a.945.945 0 0 1-.062-1.08c.273-.452.4-1.065.455-1.577a1 1 0 0 1 .935-.9l.593-.036c.003.058.058 1.063-.22 2.118 3.466-1.793 8.346-7.496 8.4-7.559l1.143.972c-.252.296-6.21 7.256-10.066 8.424a1.117 1.117 0 0 1-.322.048",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 18.477H9.564c-4.915 0-9.214-3.7-9.543-8.605C-.339 4.493 3.935 0 9.238 0h5.267c3.625 0 7.058 1.977 8.599 5.258a9.275 9.275 0 0 1-1.281 9.948l-1.146-.966a7.778 7.778 0 0 0 1.231-7.982C20.693 3.306 17.671 1.5 14.479 1.5H9.512c-4.117 0-7.719 3.1-7.994 7.208-.302 4.505 3.278 8.269 7.72 8.269h1.012a1 1 0 0 1 1 1v.5z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9 9.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m4.8-.06c0 .796-.672 1.44-1.5 1.44s-1.5-.644-1.5-1.44c0-.794.672-1.44 1.5-1.44s1.5.646 1.5 1.44m4.8.06a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0",
  fill: "currentColor"
}));

export { chatBubbleIcon as default };
//# sourceMappingURL=chatBubbleIcon.js.map
